<template>
  <div class="card card-info">
    <div class="card-header with-border">
      <h3 class="card-title">Data Verification Report</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Faculty *</label>
            <select v-model="test.FacultyID" class="form-control">
              <option selected="selected" disabled="disabled" value="0">--Select Faculty--</option>
              <option v-for="item in faculty" v-bind:value="item.FacultyID">{{item.Name}} </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer bg-light" style="text-align: right">
      <button class="btn btn-success" type="button" v-on:click="loadData()">View Data</button>
    </div>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        test: { FacultyID: 0, DegreeID: 0 },
        degree: [],
        faculty: [],
        data: []
      }
    },
    mounted: function () {
      this.pageLoad();
    },
    methods: {
   
      pageLoad() {
      
        var vm = this;
    
        axios.post('/api/AdmissionApi/loadPage')
       
          .then(function (res) {
            vm.degree = res.data.degree;
            vm.faculty = res.data.faculty;
          })
      },
      loadData() {
        var vm = this;
        axios.post('/api/AdmissionApi/loadDataVerificationReport?FacultyID=' + vm.test.FacultyID)
          .then(function (res) {

            window.open("/Admission/DataVerificationPrint?FacultyID=" + vm.test.FacultyID, '_blank');
            
          })
      }
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/dataVerificationReport.vue